// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"786":"640ccfe2e3be3788","820":"640ccfe2e3be3788","888":"05424f8b39abf1d1"}[chunkId] + ".css";
};